import 'css-chunk:src/components/pages/SearchPage/TextSearchFilters/RelationshipSection.scss';export default {
  "RelationshipSection": "_RelationshipSection_1vlcq_1",
  "selectGroup": "_selectGroup_1vlcq_1",
  "selectGroupTitle": "_selectGroupTitle_1vlcq_5",
  "icon": "_icon_1vlcq_12",
  "select": "_select_1vlcq_1",
  "groupTitle": "_groupTitle_1vlcq_20"
};